"use client";

import { c as _c } from "react/compiler-runtime";
import { trackEmailComposerAction } from "../../analytics";
import { useEmailComposer } from "../../context";
import { EMAIL_FONTS } from "../../fonts";
import { useEditorState } from "@tiptap/react";
import { useMemo, useState } from "react";
import { Button } from "@/components/ui";
import Input from "@/components/ui/input";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cx } from "@/lib/tailwind-utils";
function labelFor(fontFamily: string): string {
  const match = EMAIL_FONTS.find(f => f.value === fontFamily);
  if (match) return match.label;
  const first = fontFamily.split(",")[0].replace(/['"]/g, "").trim();
  return first || "Arial";
}
export function FontFamilySelect() {
  const $ = _c(34);
  const {
    editor,
    styleSettings
  } = useEmailComposer();
  const [search, setSearch] = useState("");
  const [open, setOpen] = useState(false);
  let t0;
  if ($[0] !== styleSettings) {
    t0 = ctx => {
      if (!ctx.editor) {
        return styleSettings.fontFamily;
      }
      const markFamily = ctx.editor.getAttributes("textStyle").fontFamily as string;
      if (markFamily) {
        return markFamily;
      }
      return styleSettings.fontFamily;
    };
    $[0] = styleSettings;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== editor || $[3] !== t0) {
    t1 = {
      editor,
      selector: t0
    };
    $[2] = editor;
    $[3] = t0;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const editorFamily = useEditorState(t1);
  const currentFamily = editorFamily ?? styleSettings.fontFamily;
  let t2;
  if ($[5] !== currentFamily) {
    t2 = labelFor(currentFamily);
    $[5] = currentFamily;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const label = t2;
  let t3;
  bb0: {
    if (!search.trim()) {
      t3 = EMAIL_FONTS;
      break bb0;
    }
    let t4;
    if ($[7] !== search) {
      const q = search.toLowerCase();
      t4 = EMAIL_FONTS.filter(f => f.label.toLowerCase().includes(q));
      $[7] = search;
      $[8] = t4;
    } else {
      t4 = $[8];
    }
    t3 = t4;
  }
  const filtered = t3;
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = v => {
      setOpen(v);
      if (!v) {
        setSearch("");
      }
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = `Font family: ${label}`;
  let t6;
  if ($[10] !== t5) {
    t6 = <PopoverTrigger asChild={true}><Button type="button" variant="ghost" size="icon-sm" tooltip={t5} className="text-caption-emphasis">Aa</Button></PopoverTrigger>;
    $[10] = t5;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = e_1 => setSearch(e_1.target.value);
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== search) {
    t8 = <div className="p-2 border-b border-border"><Input placeholder={"Search fonts\u2026"} value={search} onChange={t7} className="h-7 text-caption" autoFocus={true} /></div>;
    $[13] = search;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== filtered.length) {
    t9 = filtered.length === 0 && <p className="px-3 py-2 text-caption text-foreground-muted">No fonts found</p>;
    $[15] = filtered.length;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== currentFamily || $[18] !== editor || $[19] !== filtered) {
    let t11;
    if ($[21] !== currentFamily || $[22] !== editor) {
      t11 = font => {
        const isActive = font.value === currentFamily;
        return <button key={font.label} type="button" className={cx("flex w-full items-center rounded-md px-3 py-1.5 text-body transition-colors", isActive ? "bg-primary/10 text-foreground" : "text-foreground hover:bg-hover")} style={{
          fontFamily: font.value
        }} onMouseDown={_temp3} onClick={() => {
          if (!editor) {
            return;
          }
          editor.chain().focus().setFontFamily(font.value).run();
          trackEmailComposerAction("font_family_changed", "toolbar", {
            family: font.label
          });
          setOpen(false);
          setSearch("");
        }}>{font.label}</button>;
      };
      $[21] = currentFamily;
      $[22] = editor;
      $[23] = t11;
    } else {
      t11 = $[23];
    }
    t10 = filtered.map(t11);
    $[17] = currentFamily;
    $[18] = editor;
    $[19] = filtered;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[24] !== t10 || $[25] !== t9) {
    t11 = <div className="max-h-60 overflow-y-auto p-1">{t9}{t10}</div>;
    $[24] = t10;
    $[25] = t9;
    $[26] = t11;
  } else {
    t11 = $[26];
  }
  let t12;
  if ($[27] !== t11 || $[28] !== t8) {
    t12 = <PopoverContent align="start" sideOffset={6} className="w-52 p-0" onOpenAutoFocus={_temp} onCloseAutoFocus={_temp2}>{t8}{t11}</PopoverContent>;
    $[27] = t11;
    $[28] = t8;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== open || $[31] !== t12 || $[32] !== t6) {
    t13 = <Popover open={open} onOpenChange={t4}>{t6}{t12}</Popover>;
    $[30] = open;
    $[31] = t12;
    $[32] = t6;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
}
function _temp3(e_2) {
  return e_2.preventDefault();
}
function _temp2(e_0) {
  return e_0.preventDefault();
}
function _temp(e) {
  return e.preventDefault();
}